import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import { TICKET_CATEGORY_DETAIL_QUERY } from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const { data, loading } = useQuery(TICKET_CATEGORY_DETAIL_QUERY, {
    variables: { id: match.params.id },
  });

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && data && data.AdminTicketCategoryDetail) {
    const {
      AdminTicketCategoryDetail: { id, ticketConfig, commonStatus, icon, name },
    } = data;
    return (
      <Presenter
        history={history}
        match={match}
        location={location}
        id={id}
        ticketConfig={ticketConfig}
        commonStatus={commonStatus}
        icon={icon}
        name={name}
      ></Presenter>
    );
  }
});
